import { openCloseToast } from "../../../../Global/actions";
import { getHistoricNotificationsInbox, doNotificationToReadMassiveByFilters, doNotificationToRead, getNotificationCompanies } from "../../../../../services/NotificacionesApi";
import { setHeaderNotifications } from "../../../../Header/Notificaciones/actions";
import { store } from "../../../../../config/store";
import { paths } from "../../../../../config/routes";

export const loading = (isLoading) => ({
  type: "LOADING_HISTORIAL_NOTIFICACIONES",
  isLoading,
});

export const setNotificationFilters = (filters) => ({
  type: "SET_NOTIFICATION_FILTERS",
  filters,
});

export const resetHistory = () => ({
  type: "RESET_HISTORY",
});

export const setListaNotificacionesAndTotalRows = (notificaciones, totalRows) => ({
  type: "SET_LISTA_NOTIFICACIONES_AND_TOTALROWS",
  notificaciones,
  totalRows,
});

export const setListaNotificaciones = (notificaciones) => ({
  type: "SET_LISTA_NOTIFICACIONES",
  notificaciones,
});

export const changeParameterNotification = (parameters) => ({
  type: "CHANGE_PARAMETERS_NOTIFICATION",
  parameters,
});

export const doGetUserNotificationfilters = (userRut, filters) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let companieFilters = [];
    const request = await getNotificationCompanies(userRut);
    if (request.status === 200) {
      const result = await request.json();
      if (result.Success) {
        companieFilters = buildFilterNotification(result.CompanyList, filters);
        dispatch(setNotificationFilters(companieFilters));
      }
    }
  } catch (e) {
    console.error(e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al obtener los filtros de notificaciones",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doGetUserNotifications = (parameters, companies, filters, addNotification = false, oldIndex) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const url = buildQueryStringNotifications(parameters);
    const historial = await getHistoricNotificationsInbox(url);
    const result = await historial.json();
    const notifications = addNotification ?
      store.getState().historialNotificaciones.listaNotificaciones.concat(result.Notifications) :
      result.Notifications;
    if (oldIndex) {
      parameters.pageSize = 20;
      parameters.pageIndex = oldIndex;
    }
    dispatch(changeParameterNotification(parameters));
    dispatch(setListaNotificacionesAndTotalRows(notifications, result.TotalRows));
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al obtener el historial de notificaciones",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const setNotificationsAsReadByFilter = (parameters) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const url = buildQueryStringNotificationsChangeReadStatus(parameters);
    const read = await doNotificationToReadMassiveByFilters(url);
    if (read.status === 200) {
      // Get Notification
      let historial; let unreadBox; let resultHistorial; let resultUnreadBox;
      const param = store.getState().historialNotificaciones.parameters;
      if (param.pageIndex !== 0) {
        param.pageSize *= (param.pageIndex + 1);
        param.pageIndex = 0;
      }
      const urlHistoricNotification = buildQueryStringNotifications(param);
      const urlNotificationUnread = `${store.getState().global.userData.RUT}/all/page?read=false`;
      if (store.getState().router.location.pathname === paths.configHistorialUsuario) {
        [historial, unreadBox] = await Promise.all([
          getHistoricNotificationsInbox(urlHistoricNotification),
          getHistoricNotificationsInbox(urlNotificationUnread)]);
        [resultHistorial, resultUnreadBox] = await Promise.all([historial.json(), unreadBox.json()]);
        dispatch(setListaNotificacionesAndTotalRows(resultHistorial.Notifications, resultHistorial.TotalRows));
        dispatch(setHeaderNotifications(resultUnreadBox.Notifications, resultUnreadBox.TotalUnReadNotifications));
      } else {
        [unreadBox] = await Promise.all([getHistoricNotificationsInbox(urlNotificationUnread)]);
        [resultUnreadBox] = await Promise.all([unreadBox.json()]);
        dispatch(setHeaderNotifications(resultUnreadBox.Notifications, resultUnreadBox.TotalUnReadNotifications));
      }
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al obtener el historial de notificaciones",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const setNotificationAsReadById = (Id) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const response = await doNotificationToRead(Id);
    let historial; let unreadBox; let resultHistorial; let resultUnreadBox;
    if (response.status === 200) {
      const param = store.getState().historialNotificaciones.parameters;
      if (param.pageIndex !== 0) {
        param.pageSize *= (param.pageIndex + 1);
        param.pageIndex = 0;
      }
      const urlHistoricNotification = buildQueryStringNotifications(param);
      const urlNotificationUnread = `${store.getState().global.userData.RUT}/all/page?read=false`;
      if (store.getState().router.location.pathname === paths.configHistorialUsuario) {
        [historial, unreadBox] = await Promise.all([
          getHistoricNotificationsInbox(urlHistoricNotification),
          getHistoricNotificationsInbox(urlNotificationUnread)]);
        [resultHistorial, resultUnreadBox] = await Promise.all([historial.json(), unreadBox.json()]);
        dispatch(setListaNotificaciones(resultHistorial.Notifications));
        dispatch(setHeaderNotifications(resultUnreadBox.Notifications, resultUnreadBox.TotalUnReadNotifications));
      } else {
        [unreadBox] = await Promise.all([getHistoricNotificationsInbox(urlNotificationUnread)]);
        [resultUnreadBox] = await Promise.all([unreadBox.json()]);
        dispatch(setHeaderNotifications(resultUnreadBox.Notifications, resultUnreadBox.TotalUnReadNotifications));
      }
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al obtener el historial de notificaciones",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const buildFilterNotification = (companies, filters) => {
  try {
    const newFilters = [...filters];
    if (companies) {
      companies.forEach((item) => {
        const exist = filters.find((elem) => elem.rut === item.CompanyRut);
        if (!exist) {
          newFilters.push({
            id: "company", icon: "error", name: item.CompanyName, rut: item.CompanyRut,
          });
        }
      });
    }
    return newFilters;
  } catch (error) {
    throw error;
  }
};

export const buildQueryStringNotifications = (parameters) => {
  try {
    let result = `${store.getState().global.userData.RUT}/${parameters.type}/page?pageIndex=${parameters.pageIndex}&pageSize=${parameters.pageSize}`;
    if (parameters.type === "company" && parameters.companyRut) {
      result += `&companyRut=${parameters.companyRut}`;
    }
    if (parameters.read !== null) {
      result += `&read=${parameters.read}`;
    }
    return result;
  } catch (error) {
    throw error;
  }
};

export const buildQueryStringNotificationsChangeReadStatus = (parameters) => {
  try {
    let result = `${store.getState().global.userData.RUT}/${parameters.type}`;
    if (parameters.type === "company" && parameters.companyRut) {
      result += `?companyRut=${parameters.companyRut}`;
    }
    return result;
  } catch (error) {
    throw error;
  }
};
